import { Button as TextBoxButton, TextBox } from "devextreme-react/text-box";

import { Button } from "devextreme-react/button";
import { SelectBox } from "devextreme-react/select-box";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import { StringLengthRule, Validator } from 'devextreme-react/validator';
import axiosInstance from "../../../Middleware/axiosInstance";
import ExamAndSlots from "../Components/ExamAndSlots";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import ScanListDropdown from "./ScanListDropdown";
// Sorting an Array of object
const sortAnListOfObj = (a, b) => {
    if (a.display_name > b.display_name) {
        return 1;
    }
    if (a.display_name < b.display_name) {
        return -1;
    }
    return 0;
};

const makeWorkdeskActive = () => {
    var element1 = document.getElementById("li_workdesk");
    element1.classList.add("active");

    var element2 = document.getElementById("li_callhistory");
    element2.classList.remove("active");
    var element3 = document.getElementById("li_trash");
    element3.classList.remove("active");
    var element4 = document.getElementById("li_stats");
    element4.classList.remove("active");
    var element5 = document.getElementById("li_manualOrder");
    element5.classList.remove("active");


    var element6 = document.getElementById("li_directCall");
    element6.classList.remove("active");
}
const AIUtterance = styled.div`{
    background: rgba(234, 235, 238, 0.9);
    padding: 10px;
    font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana,
        sans-serif;
    font-size: 14px;
    max-width: 600px;
    margin-bottom: 5px;
    text-align: right;
    word-wrap: normal;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}`
const UserUtterance = styled.div`{
    background: rgba(153, 213, 226, 0.9);
    padding: 10px;
    font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana,
        sans-serif;
    font-size: 14px;
    margin-bottom: 5px;
    max-width: 600px;
    text-align: left;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}`

const ManualOrder = ({ conversation_id: escalated_conversation_id, onCloseCallback }) => {

    if (escalated_conversation_id) {
        if (document.getElementById("menu-bar"))
            document.getElementById("menu-bar").style.display = "none";
    }
    const history = useHistory();
    const { operatorAssignedCenters, is_help_notes_got_an_error, customersList } = useSelector(
        (state) => state
    );

    const [isLoading, setIsLoading] = useState(null);
    const [appointmentList, setAppointmentList] = useState([]);
    const [scanFilterKeyword, setScanFilterKeyword]=useState("")
    const [showScanListDropdown,setShowScanListDropdown]=useState(false) 
    const [centerList, setCenterList] = useState([]);
    const [selectedCenterDetails, setSelectedCenterDetails] = useState({
        is_center_invalid: "invalid",
    });
    const [chat, setChat] = useState([])
    // Storing the center lists after getting the data
    useEffect(() => {
        if (operatorAssignedCenters && customersList) {
            console.log('operatorAssignedCenters = ', operatorAssignedCenters)
            console.log('customersList = ', customersList)

            const finalCenterIds = customersList.reduce((acc, customer) => {
                if (customer.start_manual_booking_from_dummy_center_only) {
                    if (customer.dummy_center_id) {
                        acc.push(customer.dummy_center_id);
                    }
                } else {
                    if (customer.center_ids.length > 0) {
                        acc.push(...customer.center_ids);
                    }
                    if (customer.dummy_center_id) {
                        acc.push(customer.dummy_center_id);
                    }
                }
                return acc;
            }, []);

            console.log('finalCenterIds = ', finalCenterIds)

            
            let modifiedCenters = [];

            for (let i = 0; i < operatorAssignedCenters.length; i++) {
                if (finalCenterIds.indexOf(parseInt(operatorAssignedCenters[i].center_id)) > -1 ) {
                    modifiedCenters.push({
                        ...operatorAssignedCenters[i],
                        center_name: `[${operatorAssignedCenters[i].center_prefix}] - ${operatorAssignedCenters[i].center_name} `,
                    });    
                }
            }
            console.log('modifiedCenters : ', modifiedCenters)
            //In Manual Order, the center will be automatically selected if user have only one center access.
            if(modifiedCenters.length==1){
                setSelectedCenterDetails((prevState) => {
                return {
                    ...prevState,
                    is_center_invalid: "valid",
                    ...modifiedCenters[0],
                };
            });   
            }
            // Sorting an list of obj via center name
            setCenterList([...modifiedCenters.sort(sortAnListOfObj)]);
        }
    }, [operatorAssignedCenters, customersList]);

    useEffect(() => {
    }, [appointmentList]);

    useEffect(() => {
        if (escalated_conversation_id !== undefined) {
            setIsLoading(true);
            axiosInstance().get(`/oi/chatty/information-state/${escalated_conversation_id}`).then(response => {
                setIsLoading(false);

                // console.log(response.data)
                // setContactNumber(response.data?.data?.mobile_number.slice(3));
                // setRequestedService(response.data?.data?.user_service_request_utterance);
                // setSelectectCenterId(response.data?.data?.center_id);

                operatorAssignedCenters.map((v) => {
                    if (parseInt(v.center_id) === response.data?.information_state?.center_id) {
                        setSelectedCenterDetails((prevState) => {
                            return {
                                ...prevState,
                                is_center_invalid: "valid",
                                ...v,
                            };
                        });
                    }
                });
                previous_conversation_details.current = response.data?.conversation_details;
                let _chat_details = []
                previous_conversation_details.current.map(each => {
                    _chat_details.push({ utterance_from: each.utterance_from === "BOT" ? "AI" : each.utterance_from, msg: each.utterance, time: moment(each.creation_date).format("h:mm:ss a") })
                })
                setChat(_chat_details);

                if (response.data?.information_state?.mobile_number !== null) {
                    contact_number_textbox_ref.current.instance.option("value", response.data?.information_state?.mobile_number)
                }
                else {
                    setIsContactNumberValid("invalid");
                    contact_number_textbox_ref.current?.instance.option("validationStatus","invalid");
                }
                requested_service_textbox_ref.current.instance.option("value", response.data?.information_state?.user_service_request_utterance?.toUpperCase())
                return response.data;
            }).catch(error => {
                setIsLoading(false);
                console.error(error)
            })
        }

        return () => {

        }
    }, [])

    // abhishek: new code after this
    const [isContactNumberValid, setIsContactNumberValid] = useState("invalid");
    const [isScanDescriptionValid, setIsScanDescriptionValid] = useState("invalid");
    const [debug, setDebug] = useState(false);

    const [startClicked, setStartClicked] = useState(false);
    const [addNewItemAllowed, setAddNewItemAllowed] = useState(true);
    const contact_number_textbox_ref = useRef();
    const requested_service_textbox_ref = useRef();
    const numberOfAppointments = useRef(0);

    const previous_conversation_details = useRef([]);


    const validate_contact_number = (e) => {
        console.log(e.value.length);
        let contact_Number=e.value ;
        // alert(e.value.length)
        const regex = /^[\d()+\s-]+$/;
         if(!regex.test(contact_Number)){
            setIsContactNumberValid("invalid");
              return
         }else{
            const isNumberValid=checkNumberIsValidAndConvertInNormalForm(contact_Number)
            setIsContactNumberValid(isNumberValid.status);
         }
    };

    const checkNumberIsValidAndConvertInNormalForm=(contact_Number)=>{
        const country_international_code=[
            {international_code:"+91",digits:10},
            {international_code:"+61",digits:9},
            {international_code:"+44",digits:10},
            {international_code:"+1",digits:10}
        ]
        //remove extra space
        contact_Number= contact_Number=contact_Number.replace(/\s+/g, "").replace("(", "").replace(")", "").replace("-", "")
        console.log("contact_Number",contact_Number)
        if(contact_Number.startsWith(0)){
            contact_Number=contact_Number.slice(1)
        }
        let result={status:"invalid",number:contact_Number}
        
        country_international_code.map((country_code)=>{
            if(contact_Number.includes(country_code.international_code) && contact_Number.slice(country_code.international_code.length).length==country_code.digits){
                result= {status:"valid",number:contact_Number}
                return result
            }
        })
        if(contact_Number.length==9 && !contact_Number.includes("+")){
            result={status:"valid",number:contact_Number}
        }else if(contact_Number.startsWith("61") && contact_Number.length==11){
            result={status:"valid",number:contact_Number.slice(2)}
        }
        
        return result
    }
    const validate_scan_description = (value) => {
        setScanFilterKeyword(value)
        if (value && value.length === 0) {
            setIsScanDescriptionValid("invalid");
            return;
        }
        setIsScanDescriptionValid(
            requested_service_textbox_ref.current.instance.option(
                "validationStatus"
            )
        );
        // setIsScanDescriptionValid("valid");
    }
    const areRequiredDetailsCaptured = () => {
        // console.log(selectedCenterDetails);
        if (isImagingCenterSelected()) {
            // console.log("requested_service_textbox_ref:", requested_service_textbox_ref.current?.instance.option("value"), requested_service_textbox_ref.current?.instance.option("validationStatus"))
            if (
                isContactNumberValid === "valid" &&
                selectedCenterDetails?.is_center_invalid && requested_service_textbox_ref.current?.instance.option("validationStatus") === "valid"
            ){
                 return false;
            }
            return true;
        }
        else {
            if (
                isContactNumberValid === "valid" &&
                selectedCenterDetails?.is_center_invalid === "valid" 
            ){
                return false;
            }
            return true;
        }
    };

    const buttonOptionsCopyContact = {
        icon: "copy",
        type: "default",
        onClick: () => {
            navigator.clipboard.writeText(
                checkNumberIsValidAndConvertInNormalForm(contact_number_textbox_ref.current.instance.option("value")).number
            );
        },
    };
    const setScanDetailsHandler=(scan_details)=>{
        requested_service_textbox_ref.current.instance.option("value",scan_details)
    }
    const initializeConversations = () => {
        if (isImagingCenterSelected()) {
            let payload = { center_id: selectedCenterDetails.center_id, scan_desc: requested_service_textbox_ref.current.instance.option("value") }

            axiosInstance().post("/oi/api/v1/ScanTypeDetails", JSON.stringify(payload), { headers: { "Content-Type": "application/json" } }).then(response => {
                // console.log(response.data);
                let modality_generic = response.data.modality_generic.split(",");
                numberOfAppointments.current = 1
                if (modality_generic.length > 1) {
                    numberOfAppointments.current = 2
                }
                let conversation_id = escalated_conversation_id || uuidv4();
                let conversations = new Array()
                for (var i = 0; i < numberOfAppointments.current; i++) {
                    let new_conversation_id = conversation_id;
                    let _is_new_conversation = true;

                    if (i > 0) {
                        new_conversation_id = new_conversation_id + "_" + i
                    }

                    if (escalated_conversation_id === new_conversation_id) {
                        _is_new_conversation = false;
                    }

                    let newItem = {
                        conversation_id: new_conversation_id,
                        center_id: selectedCenterDetails.center_id,
                        center_name: selectedCenterDetails.center_name,
                        contact_number: checkNumberIsValidAndConvertInNormalForm(contact_number_textbox_ref.current.instance.option("value")).number,
                        conversation_workflow: selectedCenterDetails.conversation_workflow,
                        is_new_conversation: _is_new_conversation
                    };
                    conversations.push(newItem)
                    console.log("conversations:", conversations)
                }
                setAppointmentList(conversations);
                setStartClicked(true);

            }).catch(error => {
                console.log("Error:" + error)
            })
        } else {
            numberOfAppointments.current = 1;
            let conversation_id = uuidv4();
            let conversations = new Array()
            for (var i = 0; i < numberOfAppointments.current; i++) {
                let new_conversation_id = conversation_id;
                if (i > 0) {
                    new_conversation_id = new_conversation_id + "_" + i
                }
                let newItem = {
                    conversation_id: new_conversation_id,
                    center_id: selectedCenterDetails.center_id,
                    center_name: selectedCenterDetails.center_name,
                    contact_number: checkNumberIsValidAndConvertInNormalForm(contact_number_textbox_ref.current.instance.option("value")).number,
                    conversation_workflow: selectedCenterDetails.conversation_workflow,
                    is_new_conversation: escalated_conversation_id == -undefined ? true : false

                };
                conversations.push(newItem)
            }
            setAppointmentList(conversations);
            setStartClicked(true);
        }
    }

    const closeConversations = () => {
        // Remove all appointments
        setAppointmentList([]);
        // Enable Start button
        setStartClicked(false);
        // Enable 'Add a new item' button
        setAddNewItemAllowed(true);
    };

    const isImagingCenterSelected = () => {
        return selectedCenterDetails.conversation_workflow === "IMAGING_APPT" ? true : false;
    }

    const showConversation = () => {
        console.log("chat:", chat)
        return chat.map((item,index) => {
            if (item.utterance_from === "AI") {
                if (item.msg === "CONVERSATION_TERMINATED_BY_CALLER" || item.msg === "CONVERSATION_TERMINATED_BY_AI") {
                    return <AIUtterance key={Math.random()} style={{ background: "pink" }}><b>AI</b>: {item.msg}<div style={{ fontSize: "x-small", fontStyle: "italic", width: "100%", textAlign: "right" }}>{item.time}</div></AIUtterance>;
                } else {
                    return <AIUtterance key={Math.random()}  style={{backgroundColor:chat.length-1==index?"#f3f5ba":"",color:chat.length-1==index?"black":""}}><b>AI</b>: {item.msg}<div style={{ fontSize: "x-small", fontStyle: "italic", width: "100%", textAlign: "right" }}>{item.time}</div></AIUtterance>;

                }
            }
            if (item.utterance_from === "USER") {
                return <UserUtterance key={Math.random()}><b>User</b>: {item.msg}<div style={{ fontSize: "x-small", fontStyle: "italic", width: "100%", textAlign: "right" }}>{item.time}</div></UserUtterance>;
            }
        });
    };
    return (
        <>

            {
                (escalated_conversation_id && isLoading === true) && <p>Loading previous conversation...</p>
            }
            {
                ((escalated_conversation_id && isLoading === false) || escalated_conversation_id === undefined) &&

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                        marginTop: "10px",
                        // border:"2px solid orange"
                    }}
                >
                    {escalated_conversation_id && <div>
                        <div style={{ display: "flex", justifyContent: "space-between" }} className="dx-label">
                            <div>Continue conversation...</div>
                        </div>
                        <hr></hr>
                    </div>}
                    <div style={{ display: "flex", justifyContent: "space-between" ,padding:"10px"}}>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <SelectBox
                                label="Center"
                                searchEnabled={true}
                                displayExpr={"center_name"}
                                value={selectedCenterDetails?.center_id}
                                valueExpr="center_id"
                                placeholder="Select a center"
                                dataSource={centerList}
                                width={500}
                                onSelectionChanged={(e) => {
                                    setSelectedCenterDetails((prevState) => {
                                        return {
                                            ...prevState,
                                            is_center_invalid: "valid",
                                            ...e.selectedItem,
                                        };
                                    });
                                }}
                                validationStatus={
                                    selectedCenterDetails?.is_center_invalid
                                }
                                disabled={escalated_conversation_id === undefined ? false : true}
                            ></SelectBox>
                            <TextBox
                                ref={contact_number_textbox_ref}
                                label="Contact"
                                valueChangeEvent="change keyup"
                                onValueChanged={(e) => {
                                    validate_contact_number(e);
                                }}
                                validationMessageMode="always"
                                validationStatus={isContactNumberValid}
                            >
                                <TextBoxButton
                                    name="copy"
                                    location="after"
                                    options={buttonOptionsCopyContact}
                                />
                            </TextBox>
                            {/* {
                                isImagingCenterSelected() &&
                                <TextBox
                                    label="Scan description"
                                    ref={requested_service_textbox_ref}
                                    width={400}
                                    placeholder="Please enter requested scan description"
                                    // validationMessageMode="always"
                                    // validationStatus={isScanDescriptionValid}
                                    valueChangeEvent="change keyup"
                                    onValueChanged={(e) => {
                                        validate_scan_description(e);
                                    }}
                                >
                                    <Validator>
                                        <StringLengthRule min={2} message="Please specify scan description!"></StringLengthRule>
                                    </Validator>
                                </TextBox>} */}
                                  {
                                isImagingCenterSelected() &&
                                <div style={{display:"grid"}} 
                                onMouseEnter={()=>{setShowScanListDropdown(true)}}
                                onMouseLeave={()=>{setShowScanListDropdown(false)}}>
                                <TextBox
                                    label="Scan description"
                                    ref={requested_service_textbox_ref}
                                    width={400}
                                    placeholder="Please enter requested scan description"
                                    // validationMessageMode="always"
                                    // validationStatus={isScanDescriptionValid}
                                    valueChangeEvent="change keyup"
                                    onValueChanged={(e) => {
                                        validate_scan_description(e.value);
                                    }}
                                >
                                    <Validator>
                                        <StringLengthRule min={2} message=""></StringLengthRule>
                                    </Validator>
                                </TextBox>
                                <div>
                                </div>
                                {/* {showScanListDropdown && scanFilterKeyword.length>0 && <ScanListDropdown showScanListDropdown={showScanListDropdown} scanFilterKeyword={scanFilterKeyword} setScanDetailsHandler={setScanDetailsHandler}/>
                                } */}
                                </div>} 
                            <Button
                                disabled={areRequiredDetailsCaptured() || startClicked}
                                text="Start"
                                icon="arrowright"
                                type="success"
                                rtlEnabled={true}
                                onClick={initializeConversations}
                            ></Button>
                            {appointmentList.length > 1 && <div style={{ color: "red", margin: "auto", fontWeight: "bold" }}>This service requires {appointmentList.length} appointments.</div>}
                        </div>

                        {escalated_conversation_id && <div style={{ display: "flex", gap: "10px" }}>
                            {startClicked && isImagingCenterSelected() && escalated_conversation_id.includes("_") === false && <Button type="default" hint="Add a new order" icon="plus" text="Add a new item" disabled={!addNewItemAllowed} onClick={() => {
                                let new_conversation_id_suffix = `_${appointmentList.length}`
                                let new_conversation_id = appointmentList[0].conversation_id + new_conversation_id_suffix
                                let newItem = {
                                    conversation_id: new_conversation_id,
                                    center_id: selectedCenterDetails.center_id,
                                    center_name: selectedCenterDetails.center_name,
                                    contact_number: checkNumberIsValidAndConvertInNormalForm(contact_number_textbox_ref.current.instance.option("value")).number,
                                    conversation_workflow: selectedCenterDetails.conversation_workflow,
                                    is_new_conversation: true
                                };
                                setAppointmentList(prevState => [...prevState, newItem]);
                                console.log('A : ', appointmentList.length)
                                if (appointmentList.length >= 2) {
                                    setAddNewItemAllowed(false)
                                }
                            }}></Button>}
                            <Button 
                                type="danger" 
                                hint="Close Running Conversations" 
                                icon="close" 
                                onClick={() => {
                                    document.getElementById("menu-bar").style.display = "block"; 
                                    makeWorkdeskActive(); 
                                    history.push("/redirect?conversation_id=" + escalated_conversation_id); 
                                }}
                            ></Button>
                        </div>}

                        {escalated_conversation_id === undefined && <div style={{ display: "flex", gap: "10px" }}>
                            {startClicked && isImagingCenterSelected() && <Button type="default" hint="Add a new order" icon="plus" text="Add a new item" disabled={!addNewItemAllowed} onClick={() => {
                                let new_conversation_id_suffix = `_${appointmentList.length}`
                                let new_conversation_id = appointmentList[0].conversation_id + new_conversation_id_suffix
                                let newItem = {
                                    conversation_id: new_conversation_id,
                                    center_id: selectedCenterDetails.center_id,
                                    center_name: selectedCenterDetails.center_name,
                                    contact_number:checkNumberIsValidAndConvertInNormalForm(contact_number_textbox_ref.current.instance.option("value")).number ,
                                    conversation_workflow: selectedCenterDetails.conversation_workflow,
                                    is_new_conversation: true
                                };
                                setAppointmentList(prevState => [...prevState, newItem]);
                                console.log('B : ', appointmentList.length)
                                if (appointmentList.length >= 2) {
                                    setAddNewItemAllowed(false)
                                }
                            }}></Button>}
                            <Button 
                                type="danger" 
                                hint="Close Running Conversations" 
                                icon="refresh" 
                                text="Restart" 
                                disabled={!startClicked} 
                                onClick={() => {
                                    console.log('Showing alert')
                                    closeConversations()
                            }}></Button>
                        </div>}
                    </div>
                    {appointmentList.length > 0 && <div style={{
                        height: "100%",
                        // border:"2px solid brown", 
                        overflow: "hidden"
                    }}>

                        {appointmentList.map((appointment_metadata, index) => (
                            <ExamAndSlots
                                key={index}
                                index={index}
                                scan_description={requested_service_textbox_ref.current?.instance.option("value")}
                                number_of_conversations={appointmentList.length}
                                contact_number={appointment_metadata.contact_number}
                                conversation_id={appointment_metadata.conversation_id}
                                center_id={appointment_metadata.center_id}
                                conversation_workflow={appointment_metadata.conversation_workflow}
                                is_new_conversation={appointment_metadata.is_new_conversation}
                                previous_conversation_details={previous_conversation_details.current}
                            ></ExamAndSlots>
                        ))}
                    </div>}
                    {

                        appointmentList.length == 0 && previous_conversation_details.current?.length > 0 && <div style={{ overflowY: "scroll", minHeight: "0px", height: "100%", flex: "1 1 0", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px" }}>
                            {chat && showConversation()}</div>
                    }
                    {/* </div> */}
                </div>
            }
        </>
    );
};

export default ManualOrder;
